import React from 'react'
import { FormButton } from '@myxplor/forms'
import { ContentToggleIcon } from '@myxplor/icons'


const ReportSelect = ({ setCurrentReport, reports }) => (
  <div className="selector--wrapper">
    <ContentToggleIcon left open={false} />

    <select
      name='currentReport'
      onChange={({ target }) => setCurrentReport(target.value)}
    >
      <option hidden>Select a Report...</option>
      <optgroup label="Available Reports">
        {reports.map(({ id, name, description }, i) => (
          <option key={i} value={id} title={description}>
            {name}
          </option>
        ))}
      </optgroup>
    </select>
  </div>
)


const ReportSelector = ({ setCurrentReport, currentReport, reports }) => (
  currentReport ?
    <FormButton left onClick={() => setCurrentReport(null)}>
      <ContentToggleIcon left open /> Cancel
    </FormButton > :
    <ReportSelect setCurrentReport={setCurrentReport} reports={reports} />
)

export default ReportSelector


// WEBPACK FOOTER //
// ./src/reports/views/select-report.jsx